import React from 'react';

const CustomLine = () => {
  return <hr className='border border-[#B3B3B3] border-b-0' />;
};

export default CustomLine;
